// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#183e9e","secondaryColor":"#4272ae","tertiaryColor":"#7497bf","tertiaryBackgroundColor":"#e3ebf6"};